module.exports = __webpack_public_path__ + "static/img/bus-content-7.d2ba1b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bus-content-7.png
// module id = dM2H
// module chunks = 0